var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 199,
    viewBox: "0 0 79 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7993 159.391C72.8796 159.653 70.8726 159.827 68.8656 159.827C64.3281 159.827 61.1867 158.518 59.267 155.988C57.3473 153.457 56.6492 149.356 56.6492 143.51V5.98766C56.6492 3.63164 54.7295 1.71191 52.3735 1.71191H5.77658C3.42056 1.71191 1.50085 3.63164 1.50085 5.98766V151.363C1.50085 167.768 4.90399 179.373 11.8848 186.442C18.8656 193.51 30.1222 197 45.9162 197C51.8499 197 57.7836 196.215 63.5428 194.818C68.3421 193.597 72.356 192.201 75.4101 190.368C76.6318 189.583 77.4171 188.187 77.3299 186.791V158.955C76.4573 159.216 75.5846 159.391 74.712 159.565L74.7993 159.391Z",
    fill: "#191818",
    stroke: "#F57423",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL);
export default __webpack_public_path__ + "static/media/l.8ea0e77893bfe92f7ff8ff1c36d063b4.svg";
export { ForwardRef as ReactComponent };